export default __webpack_public_path__ + "static/media/whatsapp-icon.6f6e31a8.svg";